import { render } from "./new-bank-account.vue?vue&type=template&id=342c6baa"
import script from "./new-bank-account.vue?vue&type=script&lang=js"
export * from "./new-bank-account.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__